// extracted by mini-css-extract-plugin
export default {"cardsContainer":"ContentCards_cardsContainer__pPr6k"};